import { useState } from "react";

export const useFormValidation = (initialFormData) => {
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({
    correo_electronico: "",
    telefono: "",
  });

  const handleChange = (fieldOrEvent, value) => {
    const isEvent =
      fieldOrEvent && typeof fieldOrEvent === "object" && "target" in fieldOrEvent;

    const field = isEvent ? fieldOrEvent.target.name : fieldOrEvent;
    let newValue = isEvent ? fieldOrEvent.target.value : value;

    if (field === "telefono") {
      newValue = String(newValue || "").replace(/\D/g, "").slice(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    setErrors((prev) => {
      const updated = { ...prev };

      if (field === "correo_electronico") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        updated.correo_electronico =
          newValue && !emailRegex.test(newValue)
            ? "Ingresa un correo válido"
            : "";
      }

      if (field === "telefono") {
        updated.telefono =
          newValue.length > 0 && newValue.length < 10
            ? "El teléfono debe tener 10 dígitos"
            : "";
      }

      return updated;
    });
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setErrors({
      correo_electronico: "",
      telefono: "",
    });
  };

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    handleChange,
    resetForm,
  };
};
